import React from 'react'
import { Button, Modal } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels'

const translationKey = 'payApply.sign.'
export const ConfirmSignedAgreement = props => {
  const getTextIfIsPaymentElseGet = (labelPayment, fallbackLabel) => {
    if (props.isPayment) {
      return getText(translationKey + labelPayment)
    }
    return getText(translationKey + fallbackLabel)
  }

  return (
    <Modal
      show={props.show}
      onClose={props.loading ? () => {} : props.onClose}
      title={
        props.loading ? (
          <strong>
            {getText('payApply.sign.loadingAgreementNewTab')}
            <div
              style={{ display: 'inline-block', marginLeft: '20px' }}
              className={midas.loading}
            />
          </strong>
        ) : (
          <strong>
            {getTextIfIsPaymentElseGet(
              'completePayment',
              'completePaperSigning',
            )}
          </strong>
        )
      }
      hideClose
      actions={
        <div style={{ minWidth: 550 }}>
          <div
            style={{
              float: 'left',
              width: '45%',
            }}
          >
            <Button type="normal" fullWidth onClick={props.onCancel}>
              {getText('default.cancel')}
            </Button>
          </div>
          <div
            style={{
              float: 'right',
              width: '45%',
            }}
          >
            <Button
              type="primary"
              fullWidth
              onClick={props.onClose}
              disabled={props.loading}
            >
              {getTextIfIsPaymentElseGet(
                'completePayment',
                'completePaperSigning',
              )}
            </Button>
          </div>
        </div>
      }
    >
      <div style={{ minHeight: '100px' }}>
        <div>
          {getTextIfIsPaymentElseGet(
            'confirmPurchaseDescription1',
            'confirmApplicationDescription1',
          )}
        </div>
        <div>
          {getTextIfIsPaymentElseGet(
            'confirmPurchaseDescription2',
            'confirmApplicationDescription2',
          )}
        </div>
        <p>
          <a
            style={{ cursor: 'pointer' }}
            href={props.reopenAgreementUrl}
            target="_blank"
            rel="noreferrer noopener"
          >
            {getText('payApply.sign.reopenAgreement')}
          </a>
        </p>
      </div>
    </Modal>
  )
}
